// ADR-0125: the Spark Types, one per harm a single customer's report names
// first, as legacy's `spark_*` labels were.
export enum SparkTypeKey {
  DECEPTION = "customer_deception_incident",
  SALES_CONDUCT = "customer_sales_conduct_incident",
  WORKMANSHIP = "customer_workmanship_incident",
  VALUE = "customer_value_incident",
  POST_SALE_SUPPORT = "customer_post_sale_support_incident",
  PROJECT_MANAGEMENT = "customer_project_management_incident",
  STRANDED = "customer_stranded_incident",
  PREDATORY_LIEN = "customer_predatory_lien_incident",
  UNRELEASED_LIEN = "customer_unreleased_lien_incident",
  SUBCONTRACTOR_LIEN = "customer_subcontractor_lien_incident",
}

export const isSparkTypeKey = (typeKey: string): typeKey is SparkTypeKey =>
  (Object.values(SparkTypeKey) as string[]).includes(typeKey)
